<ng-container *ngFor="let tooltip of this.tooltips">
  <span
    *ngIf="tooltip.message && tooltip.show"
    [ngStyle]="{'top': tooltip.positionY + 'px', 'left': tooltip.positionX + 'px'}"
    class="bhptooltip tooltip-no-icon tooltip-correct-position"
    [ngClass]="tooltip.show ? 'tooltip-showed' : 'tooltip-hiden'"
  >
  <p class="tooltip-no-events" style="position:absolute">
      <span *ngIf="tooltip.message !== ''" style="margin-top: 0; margin-bottom: 0; color: white">
        {{tooltip.message}}
      </span>
    </p>
  </span>
</ng-container>
